import {
  callApiTaoDonViNgoai,
  callApiSuaDonViNgoai,
  callApiXoaDonViNgoai,
  callApiLayDanhSachDonViNgoaiPaging,
  callApiLayDanhSachDonViNgoai,
} from "@/api/quan-ly-template";
import { ROUTE_NAME } from "@/constants/constants";
import router from "@/router";

const layChiTietVanBan = (context, payload) => {
  context.commit("LAY_CHI_TIET_VAN_BAN_THANH_CONG", payload.vanBanId);
};

const taoVanBan = (context, payload) => {
  context.commit("TAO_VAN_BAN_THANH_CONG", payload);
  context.commit("TANG_ID_VAN_BAN");
  router.push({
    path: ROUTE_NAME.VAN_BAN.NAME + ROUTE_NAME.VAN_BAN.DANH_SACH,
  });
};

const capNhatVanBan = (context, payload) => {
  context.commit("CAP_NHAT_VAN_BAN_THANH_CONG", payload);
};

const xoaVanBan = (context, payload) => {
  context.commit("XOA_VAN_BAN_THANH_CONG", payload);
};

const layDanhSachDonViNgoaiPaging = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachDonViNgoaiPaging(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_DON_VI_NGOAI", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachDonViNgoai = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachDonViNgoai(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const taoDonViNgoai = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoDonViNgoai(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaDonViNgoai = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaDonViNgoai(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaDonViNgoai = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaDonViNgoai(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default {
  taoVanBan,
  capNhatVanBan,
  xoaVanBan,
  layChiTietVanBan,
  taoDonViNgoai,
  suaDonViNgoai,
  xoaDonViNgoai,
  layDanhSachDonViNgoai,
  layDanhSachDonViNgoaiPaging,
};
